import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Logo } from './Logo';
type SubpageHeaderProps = {
  tone?: 'light' | 'dark';
  overlay?: boolean;
};
const links = [{
  label: 'Private Line',
  to: '/private-line'
}, {
  label: 'Membership',
  to: '/membership'
}, {
  label: 'Login',
  to: '/login'
}];

// Slim header shared by the members' subpages
export function SubpageHeader({
  tone = 'light',
  overlay = false
}: SubpageHeaderProps) {
  const dark = tone === 'dark';
  const base = dark ? 'text-paper/75 hover:text-paper' : 'text-ink/65 hover:text-ink';
  const active = dark ? 'text-paper' : 'text-ink';
  return <header className={`${overlay ? 'absolute' : 'relative'} inset-x-0 top-0 z-40 ${dark ? 'text-paper' : 'border-b border-line bg-paper text-ink'} ${overlay ? 'border-b-0 bg-transparent' : ''}`} data-id="element-1155" data-mp="7ch4br8d0ghz">
      <div className="mx-auto grid h-16 max-w-[1440px] grid-cols-[1fr_auto_1fr] items-center px-6 md:h-20 md:px-16" data-id="element-1156" data-mp="100wbxsp5vwja">
        <Link to="/" className={`inline-flex items-center gap-2 justify-self-start text-[14px] font-light transition-colors duration-150 ${base}`} data-id="element-1157" data-mp="1sqo3h08f0uo3">
          <ArrowLeftIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-1158" data-mp="1izjow1mnjbts" />
          <span className="hidden sm:inline" data-id="element-1159" data-mp="1ixfm5n0hoiv3">Back to Superluxury</span>
        </Link>
        <Link to="/" aria-label="Superluxury — home" data-id="element-1160" data-mp="1nwscihqkk82f">
          <Logo className="block text-[16px] md:text-[20px]" data-id="element-1161" data-mp="19ylw6fhnyqqi" />
        </Link>
        <nav aria-label="Members" className="justify-self-end" data-id="element-1162" data-mp="1e0gst6ongfxy">
          <ul className="flex items-center gap-5 md:gap-8" data-id="element-1163" data-mp="1e1s1nkwycdvx">
            {links.map(l => <li key={l.to} className={l.to === '/membership' ? 'hidden sm:block' : ''} data-id="element-1164" data-mp="102ij4el9x7os">
                <NavLink to={l.to} className={({
              isActive
            }) => `whitespace-nowrap text-[14px] transition-colors duration-150 ${isActive ? `font-medium ${active}` : `font-light ${base}`}`} data-id="element-1165" data-mp="150alk2jjoc78">
                  {l.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>
      </div>
    </header>;
}